import React from 'react'
import PropTypes from 'prop-types'
import { FullscreenModal } from 'belle-js'
import connectModal from 'connectModal'
import modalStyles from '../Modals.module.scss'

const TrusteeInfoModal = (props) => {
  const {
    isOpen,
    closeModal,
    isActiveModal,
  } = props

  return (
    <FullscreenModal
      isOpen={isOpen}
      isActiveModal={isActiveModal}
      className={modalStyles.Modal}
      onClose={closeModal}
      testId="trusteeInfoModal">
      <h2>
        What is a Trustee?
      </h2>

      <p>
        A trustee is an individual or institution (such as a bank or trust company)
        that oversees the day-to-day management of the assets placed in a trust.
        Most grantors of revocable trusts serve as trustees themselves,
        but they can also designate any number of additional trustees.
      </p>

      <div className={modalStyles.actions}>
        <button
          type="button"
          className="button button--primary"
          onClick={closeModal}>
          Got it!
        </button>
      </div>
    </FullscreenModal>
  )
}

TrusteeInfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  isActiveModal: PropTypes.bool.isRequired
}


export default connectModal(TrusteeInfoModal, 'trusteeInfoModal')



// WEBPACK FOOTER //
// ./src/components/Onboarding/Modals/TrusteeInfoModal/TrusteeInfoModal.jsx